import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import API_ROUTES from "../../api-routes";
import apiService from "../../services/service";

export const fetchGlobalEntityDetails = createAsyncThunk(
  "globalEntities/fetchDetails",
  async () => {
    const { data } = await apiService(API_ROUTES.ALL_ENTITIES);

    return data;
  },
);

export const fetchEntityDetail = createAsyncThunk(
  "globalEntities/fetchEntityDetails",
  async (id) => {
    const { data } = await apiService(`${API_ROUTES.FETCH_ENTITY}`, "GET", {
      replace: { id },
    });
    return data;
  },
);

export const fetchServices = createAsyncThunk(
  "globalEntities/fetchServices",
  async () => {
    const { data } = await apiService(`${API_ROUTES.GET_SERVICES}`);
    return data;
  },
);

export const fetchEntityLsp = createAsyncThunk(
  "globalEntities/fetchEntityLsp",
  async (id) => {
    const { data } = await apiService(`${API_ROUTES.FETCH_ENTITY_LSP}`, "GET", {
      replace: { id },
    });
    return data;
  },
);

const globalEntitiesSlice = createSlice({
  name: "globalEntities",
  initialState: {
    entities: [],
    status: "idle",
    error: null,
    entityservices: [],
    entity_lsp: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGlobalEntityDetails.pending, (state) => {
        state.status = "loading";
        state.isEntityLoad = true;
      })
      .addCase(fetchGlobalEntityDetails.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.entities = action.payload;
        state.isEntityLoad = false;
      })
      .addCase(fetchGlobalEntityDetails.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        state.isEntityLoad = false;
      })
      .addCase(fetchEntityDetail.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchEntityDetail.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.entity_detail = action.payload;
      })
      .addCase(fetchEntityDetail.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(fetchServices.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchServices.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.entityservices = action.payload;
      })
      .addCase(fetchServices.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchEntityLsp.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchEntityLsp.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.entity_lsp = action.payload;
      })
      .addCase(fetchEntityLsp.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default globalEntitiesSlice.reducer;
